import React, { useState } from 'react';

import classNames from 'classnames';

import Button from 'CommonComponents/Button';
import EmptyState from 'CommonComponents/EmptyState';

import ChevronDownIcon from 'Assets/icons/chevron-down.svg';
import ChevronUpIcon from 'Assets/icons/chevron-up.svg';
import UsersIcon from 'Assets/icons/users.svg';

const LIST_ID = 'venue-contractors-assign-links';

export default function VenueContractorsEmptyState({ links }) {
    return (
        <EmptyState
            className="tw-py-10"
            icon={UsersIcon}
            heading={$t('No contractor packs allocated to this venue')}
            body={$t('Allocate contractor expense packs to this venue from a functional area’s Expense Packs page to see them here.')}
            action={links.length > 0 && <AssignToVenueLinks links={links} />}
        />
    );
}

function AssignToVenueLinks({ links }) {
    const [open, setOpen] = useState(false);

    const targets = links.flatMap((department) => [
        { key: `department-${department.id}`, name: department.name, url: department.url, indent: false },
        ...department.costcenters.map((costcenter) => ({ key: `costcenter-${costcenter.id}`, name: costcenter.name, url: costcenter.url, indent: true })),
    ]);
    const linked = targets.filter((target) => target.url);

    if (linked.length === 1) {
        return (
            <Button as="a" variant="primary" href={linked[0].url}>
                {$t('Go to Assign to Venue')}
            </Button>
        );
    }

    return (
        <div className="tw-flex tw-flex-col tw-items-center">
            <Button variant="primary" aria-expanded={open} aria-controls={LIST_ID} onClick={() => setOpen((prev) => !prev)}>
                <span>{$t('Go to Assign to Venue')}</span>
                {open ? <ChevronUpIcon className="tw-ms-1.5" aria-hidden="true" /> : <ChevronDownIcon className="tw-ms-1.5" aria-hidden="true" />}
            </Button>
            {open && (
                <ul
                    id={LIST_ID}
                    className="tw-mt-2 tw-min-w-[14rem] tw-max-h-80 tw-overflow-y-auto tw-rounded-lg tw-border tw-border-grey tw-bg-white tw-p-1.5 tw-text-start"
                >
                    {targets.map((target) => (
                        <li key={target.key}>
                            {target.url ? (
                                <a
                                    href={target.url}
                                    className={classNames(
                                        'tw-block tw-rounded tw-py-1.5 tw-pe-3 tw-text-xs tw-font-medium tw-text-charcoal hover:tw-bg-background hover:tw-no-underline',
                                        target.indent ? 'tw-ps-6' : 'tw-ps-3',
                                    )}
                                >
                                    {target.name}
                                </a>
                            ) : (
                                <span className="tw-block tw-px-3 tw-py-1.5 tw-text-xs tw-font-medium tw-text-charcoal-50">{target.name}</span>
                            )}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}
